import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SeatBookingData } from '../../Redux/action/seatBookingAction';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import { dataUser, dataLocation, logoutHandler } from '../Helpers/util';
import AntDDropdown from '../Common/AntDDropdown/AntDDropdown';
import SwIconButton from '../Common/SwIconButton/SwIconButton';
import SeatBookingFilterExport from './SeatBookingFilterExport';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
var exportData = [];

class SeatbookingShort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: false,
      company_id: UserObj.company_id,
      pgno: this.props.pg,
      status: 'all',
      row: this.props.rowName,

      showSeatExportModal: false,
      seat: '',
      date: '',
      amount: '',
      userRole: UserObj?.role_data || [],
      loadingExport: (
        <li style={{ color: '#666666d4', cursor: 'default' }}>
          <img src="img/submen3.svg" alt="loading" /> Loading Export Seat
          Booking
        </li>
      ),
    };

    this.handelDropdown = this.handelDropdown.bind(this);
  }

  handelDropdown() {
    this.setState(prevState => ({
      dropdown: !prevState.dropdown,
    }));
  }

  setSelectsort = e => {
    const parsh = e.target.value;
    let param = {
      pgno: this.props.pg,
      row: this.props.rowName,
      order: parsh,
      company_id: this.state.company_id,
    };

    if (!UserObj?.company_id) {
      logoutHandler();
    }
    this.props.SeatBookingData(param);
    this.props.changeshort(parsh);
  };

  refreshPage = () => {
    this.props.page(1);
    this.props.SeatBookingData({ pgno: 1, row: 25 });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.totalCount) {
      this.getAllExportData(nextProps.totalCount, nextProps);
    }
  }

  getAllExportData(totalCount, mydata) {
    exportData = mydata?.BookingListExport?.data?.list || [];

    const headers = [
      { label: 'Seat No', key: 'title' },
      { label: 'Seat Type', key: 'seat_type' },
      { label: 'Seat Category', key: 'category' },
      { label: 'Location', key: 'location_name' },
      { label: 'User Name', key: 'fullName' },
      { label: 'Email', key: 'email' },
      { label: 'Phone No.', key: 'phone' },
      { label: 'Booking Date', key: 'booking_date' },
      { label: 'Start Time', key: 'start_time' },
      { label: 'End Time', key: 'end_time' },
      { label: 'CheckIn Time', key: 'checkin_time' },
      { label: 'CheckOut Time', key: 'checkout_time' },
      { label: 'Amount', key: 'price' },
      { label: 'Status', key: 'status' },
    ];

    function getStatus(status, checkout_time) {
      if (status == 1) {
        return 'Booked';
      } else if (status == 2) {
        return 'Checked In';
      } else if (status == 3) {
        return checkout_time === 'NA' ? 'Ended' : 'Checked Out';
      } else if (status == 4) {
        return 'Cancelled';
      } else {
        return 'Unused Booking';
      }
    }

    function getSeatType(status) {
      return status === 1 ? 'Fixed' : 'Flexi';
    }

    const arr2 = exportData.map(v => ({
      booking_date: v.booking_date,
      city_name: v.city_name,
      seat_type: getSeatType(v.seat_type),
      category: v.category,
      business_name: v.business_name,
      checkin_time: v.checkin_time,
      checkout_time: v.checkout_time,
      company_name: v.company_name,
      email: v.email,
      end_time: v.end_time,
      flexi_seat_id: v.flexi_seat_id,
      floor_name: v.floor_name,
      fname: v.fname,
      lname: v.lname,
      fullName: `${v.fname} ${v.lname}`,
      location_name: v.location_name,
      phone: v.phone,
      price: v.price,
      seat_type: getSeatType(v.seat_type),
      start_time: v.start_time,
      status: getStatus(v.status, v.checkout_time),
      title: v.title,
    }));

    if (arr2.length > 0) {
      this.setState({
        loadingExport: (
          <li>
            <CSVLink
              data={arr2}
              headers={headers}
              filename={'Seat Booking.csv'}
              className="innertext"
            >
              <img src="img/submen3.svg" alt="export" /> Export Seat Booking
            </CSVLink>
          </li>
        ),
      });
    }
  }

  render() {
    const SeatBooking = this.state.userRole.find(
      element => element.service_id == '15',
    );

    return (
      <>
        <AntDDropdown
          trigger={['click']}
          placement="bottomRight"
          menu={{
            onClick: ({ key }) => {
              // Sort logic
              if (['seat', 'amount', 'date'].includes(key)) {
                this.setSelectsort({ target: { value: key } });
              }

              // Export
              if (key === 'export') {
                this.setState({ showSeatExportModal: true });
              }

              // Refresh
              if (key === 'refresh') {
                this.refreshPage();
              }
            },
            items: [
              {
                key: 'sort',
                label: 'Sort by',
                icon: <i className="bi bi-sort-down-alt" />,
                children: [
                  { key: 'seat', label: 'Seat Number' },
                  { key: 'amount', label: 'Booking Amount' },
                  { key: 'date', label: 'Booking Date' },
                ],
              },

              ...(SeatBooking?.role_for_write === '1'
                ? [
                    {
                      key: 'export',
                      icon: <i className="bi bi-upload" />,
                      label: 'Export Seat Booking',
                    },
                  ]
                : []),

              {
                key: 'refresh',
                icon: <i className="bi bi-arrow-clockwise" />,
                label: 'Refresh List',
              },
            ],
          }}
        >
          <SwIconButton size="sm">
            <i className="bi bi-list" />
          </SwIconButton>
        </AntDDropdown>

        <SeatBookingFilterExport
          show={this.state.showSeatExportModal}
          onClose={() => this.setState({ showSeatExportModal: false })}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  // seatBookingReducer: state.seatBookingReducer.BookingListExport,
});

const mapActionsToProps = {
  SeatBookingData,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(SeatbookingShort);
